<div class="d-flex align-items-center">
  <div>
    <button class="btn btn-secondary me-4 btn-sm" type="button" data-toggle="dropdown" [disabled]="restrictions.includes(customerCampaignRestrictionTypes_ReadOnly)">
      <i class="fas fa-solid fa-bars fa-no-margin"></i>
    </button>
    <ul class="dropdown-menu" role="menu">
      <ng-container *ngFor="let destinationWebsiteUrl of websiteUrls">
        <li>
          <button *ngIf="isActiveStatus(destinationWebsiteUrl)" class="btn-link dropdown-item"
            (click)="moveTrackingKeywordToWebsiteUrl(trackingKeyword, destinationWebsiteUrl)"
            [disabled]="destinationWebsiteUrl.IsReadOnly">{{ destinationWebsiteUrl.Url }}</button>
        </li>
      </ng-container>
      <div class="dropdown-divider"></div>
      <li>
        <button class="btn-link dropdown-item" (click)="archiveTrackingKeyword(trackingKeyword)">Archive</button>
      </li>
    </ul>
  </div>
  <div>
    {{ trackingKeyword.KeywordPhrase }}
  </div>
  <div *ngIf="trackingKeyword.Rank > 0" class="badge rounded-pill bg-secondary pill-text">
    Rank: {{ trackingKeyword.Rank }}
  </div>
  <div *ngIf="trackingKeyword.WasFirstPage" class="badge rounded-pill bg-info pill-text">
    First Page
  </div>
  @if (validationMessage) {
    <div class="flex-grow-1 text-danger fw-normal me-3 text-end">
      {{ validationMessage }}
    </div>
  }
</div>